import PropTypes from "prop-types";
import { memo } from "react";
import "./Category.scss";
import IconCategoryStar from "app/pages/.shared/icons/IconCategoryStar";
import IconCategoryHalfStar from "app/pages/.shared/icons/IconCategoryHalfStar";

const Category = ({ category }) => {
	const stars = [];

	if (category) {
		for (let i = 0; i < category - 1; i++) {
			stars.push(<IconCategoryStar key={i} height="1em" width="1em" />);
		}

		if (category % 1 === 0.5) {
			stars.push(<IconCategoryHalfStar key={99} height="1em" width="1em" />);
		} else {
			stars.push(<IconCategoryStar key={99} height="1em" width="1em" />);
		}
	}

	return <span className="category">{stars}</span>;
};

Category.propTypes = {
	category: PropTypes.number,
};

export default memo(Category);
